import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_apg589hg34: FaireBrandEntity = {
  token: "b_apg589hg34",
  type: "brand",
  name: "Cult Crackers",
  avatarUrl:
    "https://cdn.faire.com/fastly/59f2fc68cb98fc08af81a4dbef4f406b5cb9c4f9a4d606508573184064f7466f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/006ded0e51cbbb1233ac1e237be08e497acb6baddeb13702af600697c524440b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/59f2fc68cb98fc08af81a4dbef4f406b5cb9c4f9a4d606508573184064f7466f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/006ded0e51cbbb1233ac1e237be08e497acb6baddeb13702af600697c524440b.jpeg",
  location: "Berkeley, CA, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 169,
  isTopShop: true,
  isInsider: true,
  description:
    "Cult Crackers is a fast-growing, award-winning, woman-owned cracker company committed to making crackers that taste good and our good for you. Our crackers are hand baked with the highest-quality organic gluten-free ingredients, creating the crunchy goodness Good Housekeeping recognizes as the best gluten-free crackers.\n\nOur totally addicting crackers are not only filled with good-for-you organic ingredients, they're also packed with flavor and crunch. We hand bake our crackers in small batches at the Berkeley Kitchens, a wonderful community of small food producers in Berkeley, California. Our best-selling cracker is our Crunchy Cassava Crackers, a hearty cracker filled with crunchy goodness. Our Classic Seed Crackers offer sweet, rich flavors with a crispier texture.\n\nWhen we started Cult Crackers we decided to use our business as a force for good. We commit to being certified organic, bake every batch of crackers by hand, pay our employees a living wage, and do things with care and intention.\n\nWe love what we do, and that Cult Crackers nourish people in so many different ways.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:46.072Z",
    importedBy: "entity-db-cli",
  },
};
